// Olamee keeps every legal document on one page, deep-linked by tab.
// There is no separate User Agreement - the Terms of Use is the whole agreement.
export const TERMS_AND_CONDITIONS_URL = 'https://olamee.com/legal?tab=terms'
export const PRIVACY_POLICY_URL = 'https://olamee.com/legal?tab=privacy'
